window.prijzen = (default_id) => {
    if (location.hash) {
        default_id = location.hash.substr(1);
    }

    return {
        current: default_id,
        open(hash, event) {
            event.preventDefault();
            this.current = hash;
            window.history.pushState('Object', document.title, '/prijzen#' + hash);
        },
        is_open(id) {
            return id == this.current
        }
    }
}
